"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = { class: "cart-list-item-modal p-b-20" };
const _hoisted_2 = { class: "cart-list-item-modal__header" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_1.createElementVNode)("h5", null, "Items in your order", -1);
const _hoisted_4 = /*#__PURE__*/ (0, vue_1.createElementVNode)("label", {
    class: "iw-visuallyhidden",
    for: "cart-list-item-modal-close-btn"
}, "close", -1);
const _hoisted_5 = /*#__PURE__*/ (0, vue_1.createElementVNode)("svg", {
    height: "12px",
    width: "12px",
    version: "1.1",
    viewBox: "0 0 512 512",
    "xml:space": "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
    /*#__PURE__*/ (0, vue_1.createElementVNode)("path", { d: "M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z" })
], -1);
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { class: "cart-list-item-modal__content" };
const _hoisted_8 = { class: "cart-list-item-modal__footer" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CartListItem = (0, vue_1.resolveComponent)("CartListItem");
    const _component_app_button = (0, vue_1.resolveComponent)("app-button");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            (0, vue_1.createElementVNode)("button", {
                id: "cart-list-item-modal-close-btn",
                class: "cart-list-item-modal__close-btn",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => ($setup.hideModal && $setup.hideModal(...args)))
            }, _hoisted_6)
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_7, [
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)($props.cartItems, (product, index) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CartListItem, {
                    key: index,
                    product: product,
                    "is-confirmation": true
                }, null, 8, ["product"]));
            }), 128))
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_8, [
            (0, vue_1.createVNode)(_component_app_button, {
                text: 'Done',
                "aria-label": 'Done',
                handler: $setup.hideModal
            }, null, 8, ["handler"])
        ])
    ]));
}
exports.render = render;
